<template>
  <component
    :is="list"
    class="list"
  >
    <li
      v-for="(item, index) in children"
      :key="index"
      class="list__item"
      :class="getLiClass(item, index)"
      :style="`--start: '${index + parseInt(start)}'`"
    >
      <div
        :class="getItemWrappClass(item)"
        class="list__item-wrapp"
      >
        <TheContent
          v-for="itemChildren in item.children"
          :key="itemChildren.id"
          :elem="itemChildren"
        />
      </div>
    </li>
  </component>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TContent } from '~/types/common';
  import type { IContentList } from '~/types/components/BHList';
  import TheContent from '~/components/TheContent';

  export default defineNuxtComponent({
    name: 'BHList',
    components: { TheContent },

    props: {
      elem: {
        type: Object as PropType<IContentList>,
        required: true,
      },
    },

    computed: {
      list(): string {
        return this.ordered ? 'ol' : 'ul';
      },

      children(): TContent[] {
        return this.elem.children;
      },

      ordered(): boolean {
        return this.elem.attributes.ordered;
      },

      start(): string {
        return this.elem.attributes.start || '1';
      },

      cssVariables(): string {
        return `
        --start: ${this.start};
      `;
      },
    },

    methods: {
      getLiClass(item: TContent, index: number): any[] {
        return [
          {
            'list__item--two-symbol': (index > 8 || parseInt(this.start) > 9) && this.ordered,

            'list__item--wrap': item.children[0]
              ? item.children[0].type === 'bh-kiss__list'
              : false,
          },
        ];
      },

      getItemWrappClass(item: TContent): Record<string, boolean> {
        return {
          'list__item-wrapp--wrap': item.children[0]
            ? item.children[0].type === 'bh-kiss__list'
            : false,
        };
      },
    },
  });
</script>

<!-- Одинаковые стили для мобильной версии и amp-->
<style lang="scss" src="@/scss/amp/bh-list.amp.scss" scoped />
